<template>
  <div id="preview-modal" class="modal preview-modal" v-show="modalShown" @click="onOutRange()">
    <div class="modal-main" id="sheet-preview" @mouseover="isOnSheet = true" @mouseout="isOnSheet = false">
      <div class="title_area">
        <div class="cross_btn" @click="close()">
          <span class="css-cancel"></span>
        </div>
        <h2 class="title">図面</h2>
      </div>
      <div class="hidden-overflow" id="preview_sheet_area">
        <section id="preview_plan">
          <dd-sheet
            ref="sheetModalRef"
            :spaceJoincd="spaceJoincd"
            :isPreview=true
            :svgWidth="svgWidth"
            :svgHeight="svgHeight"
            :isShowInfo="isShowInfo"
            @showModal="delayShowModal"
          />
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import * as Check from '../../../../../utils/Check'
import Sheet from './EstimateSheet'

export default {
  name: 'estimateModal',
  components: {
    'dd-sheet': Sheet
  },
  props: {
    spaceJoincd: String,
    isShowInfo: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modalShown: false,
      svgWidth: '90%',
      svgHeight: '100%',
      isOnSheet: false
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    showModal: function () {
    },
    delayShowModal: function () {
      // 図面が完成してから表示
      this.modalShown = true
      this.$nextTick(function () {
        if (!Check.isBrawserIE()) return
        let modalWidth = document.getElementById('sheet-preview').clientWidth
        let modalHeight = document.getElementById('sheet-preview').clientHeight
        // 親領域のpadding、右のスクロールバーを引く
        this.svgWidth = (modalWidth - 20 - 20) + 'px'
        this.svgHeight = (modalHeight - 52 - 15 - 40) + 'px'
      })
    },
    onOutRange: function () {
      if (!this.isOnSheet) {
        this.close()
      }
    },
    close: function () {
      this.modalShown = false
    }
  }
}
</script>
<style src="../../../../css/style.scss" lang="scss" scoped></style>
<style src="../../../../css/dctop.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/input/estimate/SheetPreviewModal.vue